import { getCurrentUserInfo } from '@services/Cookies';
import { refreshToken } from '@services/api/api';
import {
  getSessionKeepAlivePriorityActive,
  subscribeSessionKeepAlivePriority,
} from '@services/sessionKeepAliveState';
import { useEffect, useState } from 'react';

const NORMAL_KEEP_ALIVE_INTERVAL_MS = 5 * 60 * 1000;
const PRIORITY_KEEP_ALIVE_INTERVAL_MS = 60 * 1000;

export const useSessionKeepAlive = () => {
  const [priorityActive, setPriorityActive] = useState(getSessionKeepAlivePriorityActive());

  useEffect(() => {
    return subscribeSessionKeepAlivePriority(setPriorityActive);
  }, []);

  useEffect(() => {
    const interval = window.setInterval(() => {
      if (!getCurrentUserInfo()) {
        return;
      }

      refreshToken();
    }, priorityActive ? PRIORITY_KEEP_ALIVE_INTERVAL_MS : NORMAL_KEEP_ALIVE_INTERVAL_MS);

    return () => {
      window.clearInterval(interval);
    };
  }, [priorityActive]);
};
